import Accordion from '@/scripts/optional/accordion'

document.addEventListener('DOMContentLoaded', () => {
	new Accordion({
		el: '.faq-main-item',
		trigger: '.accordion-el__head',
		showOne: true
	})

	const toggleBtn = document.querySelector('.js-faq-toggle') as HTMLButtonElement;
	const faqContainer = document.querySelector('.js-faq-items');

	if (toggleBtn && faqContainer) {
		toggleBtn.addEventListener('click', () => {
			const isExpanded = faqContainer.classList.toggle('is-expanded');
			const text = isExpanded ? toggleBtn.dataset.readLess : toggleBtn.dataset.readAll;
			if (text) {
				toggleBtn.textContent = text;
			}
		});
	}
})